import { toast } from "sonner";

// Shared copy-to-clipboard: write text + success toast.
// message defaults to "Copied to clipboard"; pass a label for a custom toast.
export function copyToClipboard(text, message = "Copied to clipboard") {
  navigator.clipboard.writeText(text);
  toast.success(message);
}
